import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import cx from 'clsx';

import {
  IconDefaultToken,
  IconRcDefaultNft,
  IconRcUnconfirmedToken,
  IconRcUnconfirmedTokenDark,
} from '@/assets/icon/token';
import { HelperTooltip, LazyMedia } from '@/components';
import { CHAINS_DICT } from '@/utils/chain';

import style from './index.module.css';
import { useTheme } from '@/hooks';

interface Props {
  className?: string;
  chain?: string;
  logo?: string;
  size?: number;
  chainClassName?: string;
  logoClassName?: string;
  chainSize?: number;
  isUnconfirmed?: boolean;
  isNft?: boolean;
}

export const TokenAvatar = (props: Props) => {
  const { t } = useTranslation();

  const {
    className,
    logo,
    size = 32,
    chain,
    chainClassName,
    logoClassName,
    chainSize = size / 2,
    isUnconfirmed,
    isNft,
  } = props;

  const { isDark } = useTheme();

  const chainLogo = useMemo(() => chain && CHAINS_DICT[chain]?.logo, [chain]);
  const logoStyle = useMemo(
    () => ({
      width: size,
      height: size,
    }),
    [size],
  );

  const chainStyle = useMemo(
    () =>
      chainSize
        ? {
            width: chainSize,
            height: chainSize,
          }
        : undefined,
    [chainSize],
  );

  const UnConfirmToken = useMemo(
    () => (isDark ? IconRcUnconfirmedTokenDark : IconRcUnconfirmedToken),
    [isDark],
  );

  return (
    <div className={cx(style.iconWithChain, className)}>
      <div style={logoStyle}>
        {isUnconfirmed ? (
          <HelperTooltip
            title={t('TokenAvatar.16xul0q')}
            align={{ targetOffset: [8, 0] }}
            placement="topLeft">
            <img src={UnConfirmToken} alt="" style={logoStyle} />
          </HelperTooltip>
        ) : (
          <LazyMedia
            className={cx(style.icon, isNft && style.isNft, logoClassName)}
            src={logo}
            alt=""
            failedPlaceholder={
              isNft ? (
                <IconRcDefaultNft style={logoStyle} />
              ) : (
                <img src={IconDefaultToken} alt="" style={logoStyle} />
              )
            }
          />
        )}
      </div>
      {chainLogo ? (
        <img
          style={chainStyle}
          className={cx(style.chainLogo, chainClassName)}
          src={chainLogo}
          alt=""
        />
      ) : null}
    </div>
  );
};
